
export default function AnchorSuccessSection() {
  const successStories = [
    {
      name: '小茉莉直播间',
      avatar: 'https://public.readdy.ai/ai/img_res/86c02262e203d0a78513c44d881702a5.jpg',
      platform: '抖音直播',
      fans: '68万粉丝',
      achievement: '月销售额180万',
      story: '从新手主播到茶叶带货专家，通过专业培训和优质产品支持，3个月内实现销售额翻倍。',
      highlight: '转化率高达12%',
      tags: ['茶叶专家', '高转化率', '稳定收入']
    },
    {
      name: '茶香飘万家',
      avatar: 'https://readdy.ai/api/search-image?query=Experienced%20male%20tea%20master%20and%20livestream%20host%2C%20knowledgeable%20appearance%2C%20traditional%20tea%20ceremony%20background%2C%20professional%20tea%20tasting%20setup%2C%20authoritative%20and%20trustworthy%20presence&width=150&height=150&seq=anchor-02&orientation=squarish',
      platform: '快手直播',
      fans: '42万粉丝',
      achievement: '月销售额120万',
      story: '资深茶艺师转型直播带货，凭借专业知识和我们的产品支持，快速建立了忠实客户群。',
      highlight: '客户回购率85%',
      tags: ['茶艺专家', '高回购率', '品牌忠诚']
    },
    {
      name: '云南普洱小妹',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20female%20tea%20enthusiast%20with%20authentic%20regional%20background%2C%20warm%20and%20genuine%20smile%2C%20traditional%20tea%20farm%20environment%2C%20natural%20and%20approachable%20personality%2C%20regional%20tea%20culture%20representative&width=150&height=150&seq=anchor-03&orientation=squarish',
      platform: '淘宝直播',
      fans: '35万粉丝',
      achievement: '月销售额85万',
      story: '原产地优势结合专业运营支持，在短短半年内从小主播成长为区域知名茶叶带货主播。',
      highlight: '粉丝增长300%',
      tags: ['原产地优势', '快速成长', '区域影响力']
    }
  ];

  const achievements = [
    {
      title: '合作主播数量',
      value: '500+',
      description: '已与500多位优质主播建立合作关系',
      icon: 'ri-user-star-line',
      color: 'from-blue-500 to-blue-600'
    },
    {
      title: '月均销售额',
      value: '2000万+',
      description: '所有合作主播月均总销售额超过2000万',
      icon: 'ri-money-dollar-circle-line',
      color: 'from-blue-500 to-blue-600'
    },
    {
      title: '平均佣金收入',
      value: '15万+',
      description: '头部主播月均佣金收入超过15万元',
      icon: 'ri-trophy-line',
      color: 'from-slate-500 to-slate-600'
    },
    {
      title: '客户满意度',
      value: '98%',
      description: '客户满意度高达98%，口碑极佳',
      icon: 'ri-heart-line',
      color: 'from-blue-500 to-blue-600'
    }
  ];

  return (
    <section id="success" className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            成功案例
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            看看我们的合作主播是如何通过专业支持实现事业突破的
          </p>
        </div>

        {/* Success Stories */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {successStories.map((story, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group hover:transform hover:scale-105"
            >
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <img
                    src={story.avatar}
                    alt={story.name}
                    className="w-16 h-16 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h3 className="text-base md:text-lg font-bold text-gray-800">{story.name}</h3>
                    <p className="text-xs md:text-sm text-gray-500">{story.platform} · {story.fans}</p>
                  </div>
                </div>
                
                <div className="mb-4">
                  <div className="text-xl md:text-2xl font-bold text-blue-600 mb-1">
                    {story.achievement}
                  </div>
                  <div className="text-xs md:text-sm text-slate-600 font-medium">
                    {story.highlight}
                  </div>
                </div>
                
                <p className="text-xs md:text-sm text-gray-600 leading-relaxed mb-4">
                  {story.story}
                </p>
                
                <div className="flex flex-wrap gap-2">
                  {story.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className="px-2 py-1 bg-blue-100 text-blue-600 text-xs rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Achievements */}
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h3 className="text-xl md:text-2xl font-bold text-center text-gray-800 mb-8">平台数据表现</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {achievements.map((achievement, index) => (
              <div key={index} className="text-center">
                <div className={`w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-r ${achievement.color} flex items-center justify-center`}>
                  <i className={`${achievement.icon} text-white text-2xl`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                  {achievement.value}
                </div>
                <div className="text-sm md:text-base font-medium text-gray-800 mb-1">
                  {achievement.title}
                </div>
                <div className="text-xs md:text-sm text-gray-600">
                  {achievement.description}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div className="mt-16">
          <h3 className="text-xl md:text-2xl font-bold text-center text-gray-800 mb-8">主播评价</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-6">
              <div className="flex items-start mb-4">
                <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-double-quotes-l text-white text-xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-800 text-sm md:text-base">@茶语小筑</div>
                  <div className="text-xs md:text-sm text-gray-600">抖音主播 · 25万粉丝</div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                "合作半年多了，产品质量真的很好，客服支持也很到位。从一开始的茶叶小白到现在能独当一面，真的很感谢平台的培训和支持。"
              </p>
            </div>
            
            <div className="bg-gradient-to-r from-slate-50 to-slate-100 rounded-xl p-6">
              <div className="flex items-start mb-4">
                <div className="w-12 h-12 bg-slate-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-double-quotes-l text-white text-xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-800 text-sm md:text-base">@功夫茶师</div>
                  <div className="text-xs md:text-sm text-gray-600">快手主播 · 58万粉丝</div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
                "佣金结算很及时，产品线也很丰富。最重要的是售后服务做得好，客户满意度很高，回购率也不错。推荐新主播来试试。"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
